import { capture } from "./capture";

export const DatasetsTracking = {
  /** Dataset detail page viewed. */
  detailViewed: (tableId: string, tableName: string) => {
    capture("datasets.detail_viewed", { table_id: tableId, table_name: tableName });
  },

  /** Schema tab viewed on dataset detail page. */
  schemaViewed: (tableId: string) => {
    capture("datasets.schema_viewed", { table_id: tableId });
  },

  /** AI description generated for a dataset. */
  aiDescriptionGenerated: (tableId: string) => {
    capture("datasets.ai_description_generated", { table_id: tableId });
  },

  /** Purpose/description manually edited. */
  purposeEdited: (tableId: string) => {
    capture("datasets.purpose_edited", { table_id: tableId });
  },

  /** AI analysis started via "Analyse the table" button. */
  aiAnalysisStarted: (tableName: string) => {
    capture("datasets.ai_analysis_started", { table_name: tableName });
  },

  /** Lineage tab viewed on dataset detail page. */
  lineageViewed: (tableId: string) => {
    capture("datasets.lineage_viewed", { table_id: tableId });
  },

  /** Opportunity selected on dataset detail page. */
  opportunitySelected: (tableId: string, opportunityId: string) => {
    capture("datasets.opportunity_selected", { table_id: tableId, opportunity_id: opportunityId });
  },
};
